import en from 'element-ui/lib/locale/lang/en';

export default {
  element: en,
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/element.js